import React, { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { withTranslation } from 'react-i18next';
import {
    ButtonGroup,
    InternalGrid,
    ModalControl,
    ModalProvider,
    DaButton,
    OutIcon,
    CheckBoldIcon,
    ArrowRightIcon,
} from '@paygreen/paygreen-ui';
import { ActionBadge, H1Title, ErrorBoundary } from '../../../components';
import { spaces } from '../../../utils/constants';
import { useUser } from '../../../context';
import { charityEnvLink } from '../shared';
import SpaceCard from './SpaceCard';
import UserSpaceModal from './UserSpaceModal';

const UserSpaces = ({ t }) => {
    const { user } = useUser();

    // we create a ref to detect if component is mounted
    const isMounted = useRef(false);

    useEffect(() => {
        isMounted.current = true;

        return () => {
            isMounted.current = false;
        };
    }, []);

    const ActivatedBadge = (props) => (
        <ActionBadge
            text={t('form.button.activated')}
            icon="CheckBoldIcon"
            colorStatus="success"
            isStrong={true}
            {...props}
        />
    );

    return (
        <>
            <Helmet>
                <title>
                    {t('user.spaces.metaTitle')} - {t('main.metaTitle')}
                </title>
            </Helmet>

            <H1Title title={t('user.spaces.title')} />

            <div>
                <InternalGrid
                    flexWrap="wrap"
                    justifyContent="flex-start"
                    childrenMarginLateral="md"
                    childrenMarginTop="md"
                >
                    <ErrorBoundary>
                        <SpaceCard space={spaces.climate}>
                            <ButtonGroup marginBottom="sm" marginTop="xs">
                                <ActivatedBadge className="activated-climate" />
                            </ButtonGroup>
                        </SpaceCard>
                    </ErrorBoundary>

                    <ErrorBoundary>
                        <SpaceCard>
                            <ButtonGroup
                                marginBottom="sm"
                                marginTop="xs"
                                style={{ alignItems: 'center' }}
                            >
                                <ModalProvider>
                                    <>
                                        {user?.usesArrondi === '1' ? (
                                            <>
                                                <ActivatedBadge className="activated-charity" />

                                                <a
                                                    href={charityEnvLink()}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="open-charity"
                                                >
                                                    <DaButton
                                                        buttonSize="sm"
                                                        gradient="theme"
                                                        colorTheme="quaternary"
                                                        icon={
                                                            <ArrowRightIcon />
                                                        }
                                                    >
                                                        {t('form.button.open')}
                                                    </DaButton>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                <a
                                                    href="https://paygreen.io/arrondi-en-ligne/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <DaButton
                                                        buttonSize="sm"
                                                        buttonStyle="line"
                                                        colorPallet="theme"
                                                        gradient="theme"
                                                        colorTheme="quaternary"
                                                        icon={<OutIcon />}
                                                    >
                                                        {t(
                                                            'form.button.knowMore',
                                                        )}
                                                    </DaButton>
                                                </a>

                                                <ModalControl
                                                    hasOnClickControl={true}
                                                >
                                                    <button type="submit">
                                                        <DaButton
                                                            buttonSize="sm"
                                                            gradient="theme"
                                                            colorTheme="quaternary"
                                                            icon={
                                                                <CheckBoldIcon />
                                                            }
                                                        >
                                                            {t(
                                                                'form.button.activate',
                                                            )}
                                                        </DaButton>
                                                    </button>
                                                </ModalControl>
                                            </>
                                        )}

                                        <ModalControl>
                                            <UserSpaceModal />
                                        </ModalControl>
                                    </>
                                </ModalProvider>
                            </ButtonGroup>
                        </SpaceCard>
                    </ErrorBoundary>
                </InternalGrid>
            </div>
        </>
    );
};

export default withTranslation('common')(UserSpaces);
